function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// During server-side rendering, there are additional onfocus onblur attributes that get added to the InputField
// used by AutocompleteField. This is a bug in react-hotkeys.
// Because of different attributes, React cannot hydrate properly since the markup is not what it expects.
// This works around the issue by showing the InputField during SSR without any React-hotkeys wrapper.
import React from 'react';
import AutocompleteField from 'eventbrite_design_system/autocompleteField/AutocompleteField';
import InputField from 'eventbrite_design_system/inputField/InputField';

var BareAutocompleteField = function BareAutocompleteField(_ref) {
  var id = _ref.id,
      placeholder = _ref.placeholder,
      prefix = _ref.prefix;
  return React.createElement("div", {
    className: "eds-autocomplete-field",
    "data-spec": "autocompletefield-field"
  }, React.createElement("div", {
    className: "eds-autocomplete-field__dropdown-holder"
  }, React.createElement(InputField, {
    id: id,
    style: "basic",
    label: "autocomplete",
    placeholder: placeholder,
    prefix: prefix,
    borderType: "none"
  })));
};

var AutocompleteFieldWithFallback =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(AutocompleteFieldWithFallback, _React$Component);

  function AutocompleteFieldWithFallback() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      isInBrowser: false
    });

    return _this;
  }

  var _proto = AutocompleteFieldWithFallback.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.setState({
      isInBrowser: true
    });
  };

  _proto.render = function render() {
    return this.state.isInBrowser ? React.createElement(AutocompleteField, this.props) : React.createElement(BareAutocompleteField, this.props);
  };

  return AutocompleteFieldWithFallback;
}(React.Component);

export { AutocompleteFieldWithFallback as default };